import plans from './plans'
import countries from './countries'
import quotas from './quotas'
import stickies from './stickies'

export default {
    plans,
    countries,
    quotas,
    stickies,
}